import type { SalesOrder } from "./index";
import { getOrderColumns } from "Common/Components/orderColumns";
import { isSettled } from "Common/constants/proformaStatus";

export interface SalesOrdersColumnsProps {
  mayRegisterPayment: boolean;
  getSalesExpertName: (
    order: Pick<SalesOrder, "sales_expert_username" | "sales_expert_fullname">
  ) => string;
  handleViewDetails: (order: SalesOrder) => void;
  handleViewPayments: (order: SalesOrder) => void;
  handleOpenRegisterPayment: (order: SalesOrder) => void;
}

// این صفحه از نظر وضعیت سفارش فقط‌خواندنی است؛ تنها ستون‌های مشترک را دارد و ستون
// «عملیات» ندارد. ترتیب ستون‌ها عمداً با پیش‌فاکتورها یکی است چون رکورد از آنجا می‌آید.
export const getSalesOrdersColumns = ({
  mayRegisterPayment,
  getSalesExpertName,
  handleViewDetails,
  handleViewPayments,
  handleOpenRegisterPayment,
}: SalesOrdersColumnsProps) =>
  getOrderColumns({
    getSalesExpertName,
    onViewSpecs: handleViewDetails,
    onViewPayments: handleViewPayments,
    onRegisterPayment: handleOpenRegisterPayment,
    canRegisterPayment: (order: SalesOrder) => mayRegisterPayment && !isSettled(order),
  });
